import { Helmet } from "react-helmet-async";

/**
 * SEO component for managing page-level meta tags
 * @param {Object} props
 * @param {string} props.title - Page title
 * @param {string} props.description - Page description  
 * @param {string} props.canonical - Canonical URL
 * @param {string} props.image - OG image URL
 * @param {string} props.type - OG type (website, article, profile)
 * @param {Object} props.structuredData - JSON-LD structured data
 */
const SEO = ({ 
  title = "360Lumina | Professional Photography Business Management",
  description = "360Lumina helps photographers streamline their business with booking management, client galleries, contracts, payments, and more.",
  canonical,
  image = "https://www.360lumina.com/og-image.png",
  type = "website",
  structuredData,
  noIndex = false
}) => {
  const siteUrl = "https://www.360lumina.com";
  const fullTitle = title.includes("360Lumina") ? title : `${title} | 360Lumina`;
  const canonicalUrl = canonical || (typeof window !== 'undefined' ? window.location.href : siteUrl);

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="360Lumina" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonicalUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
